import React, { useState, useEffect } from "react";

const API = process.env.REACT_APP_API_URL || "http://localhost:5000";

export function SharedView() {
  const [share,   setShare]   = useState(null);
  const [loading, setLoading] = useState(true);
  const [error,   setError]   = useState("");

  useEffect(() => {
    // Extract token from /shared/:token URL path
    const parts = window.location.pathname.split("/");
    const token = parts[parts.indexOf("shared") + 1];
    if (!token) { setError("Invalid share link — no token found."); setLoading(false); return; }

    (async () => {
      try {
        const res = await fetch(`${API}/api/share/${token}/public`);
        if (res.status === 410) { setError("This link has expired."); setLoading(false); return; }
        if (res.status === 404) { setError("Share not found. This link may have been revoked."); setLoading(false); return; }
        if (!res.ok)            { setError("Failed to load shared view."); setLoading(false); return; }
        setShare(await res.json());
      } catch { setError("Network error — please check your connection."); }
      setLoading(false);
    })();
  }, []);

  const bg = "#020617";
  const surface = "#0f172a";
  const border  = "#1e293b";
  const text    = "#f1f5f9";
  const muted   = "#64748b";

  if (loading) return (
    <div style={{ minHeight: "100vh", background: bg, display: "flex", alignItems: "center", justifyContent: "center", fontFamily: "Georgia, serif" }}>
      <div style={{ color: muted, fontSize: 14 }}>Loading shared view…</div>
    </div>
  );

  if (error) return (
    <div style={{ minHeight: "100vh", background: bg, display: "flex", alignItems: "center", justifyContent: "center", fontFamily: "Georgia, serif", padding: 20 }}>
      <div style={{ background: surface, border: `1px solid ${border}`, borderRadius: 20, padding: 40, textAlign: "center", maxWidth: 420 }}>
        <div style={{ fontSize: 40, marginBottom: 16 }}>🔗</div>
        <div style={{ fontSize: 18, fontWeight: 900, color: text, marginBottom: 8 }}>Link Unavailable</div>
        <div style={{ fontSize: 13, color: muted }}>{error}</div>
      </div>
    </div>
  );

  return (
    <div style={{ minHeight: "100vh", background: bg, fontFamily: "Georgia, serif", color: text, padding: "32px 24px" }}>
      <div style={{ maxWidth: 900, margin: "0 auto" }}>
        <div style={{ marginBottom: 32, paddingBottom: 20, borderBottom: `1px solid ${border}` }}>
          <div style={{ fontSize: 11, color: muted, textTransform: "uppercase", letterSpacing: 1, marginBottom: 6, fontWeight: 700 }}>
            Alpha Media Analytics · Shared View
          </div>
          <h1 style={{ margin: 0, fontSize: 24, fontWeight: 900, letterSpacing: "-0.5px" }}>{share.title}</h1>
          <div style={{ marginTop: 6, fontSize: 12, color: muted, display: "flex", gap: 14, flexWrap: "wrap" }}>
            <span>Section: <strong style={{ color: "#60a5fa" }}>{share.tab}</strong></span>
            <span>Created: {new Date(share.createdAt).toLocaleDateString()}</span>
            {share.expiresAt && <span>Expires: {new Date(share.expiresAt).toLocaleDateString()}</span>}
          </div>
        </div>

        <div style={{ background: surface, border: `1px solid ${border}`, borderRadius: 18, padding: 32, textAlign: "center" }}>
          <div style={{ fontSize: 40, marginBottom: 16 }}>📊</div>
          <div style={{ fontSize: 16, fontWeight: 700, color: text, marginBottom: 8 }}>Read-Only Dashboard View</div>
          <div style={{ fontSize: 13, color: muted, maxWidth: 440, margin: "0 auto", lineHeight: 1.6 }}>
            This shared link gives read-only access to the <strong style={{ color: "#60a5fa" }}>{share.tab}</strong> section of the Alpha Media Analytics Dashboard.
            <br /><br />
            To access the full interactive dashboard, please sign in with your Alpha Media account.
          </div>
          <a href="/" style={{ display: "inline-block", marginTop: 20, background: "#2563EB", color: "#fff", textDecoration: "none", padding: "10px 24px", borderRadius: 10, fontSize: 13, fontWeight: 800 }}>
            Sign In →
          </a>
        </div>

        <div style={{ marginTop: 24, textAlign: "center", fontSize: 11, color: muted }}>
          Alpha Media Holdings · Analytics Dashboard
        </div>
      </div>
    </div>
  );
}
